export enum PredefinedRole {
    
    ADMIN = "Admin",

    POWER_USER = "PowerUser",

    USER = "User",

    GUEST = "Guest",
}